import React from 'react';

import { Box, Typography } from '@mui/material';

interface Props {
  label: string;
  value?: string;
  width: number;
}

export default function DetailField({ label, value, width }: Props) {
  return (
    <Box sx={{ minWidth: 0, width: { xs: '100%', md: width }, flexShrink: 0 }}>
      <Typography
        variant="caption"
        fontWeight={700}
        color="text.secondary"
        sx={{ letterSpacing: '0.06em', display: 'block', textTransform: 'uppercase' }}
      >
        {label}
      </Typography>
      <Typography variant="body2" color={value ? 'text.primary' : 'text.disabled'}>
        {value || 'N/A'}
      </Typography>
    </Box>
  );
}
